import React, { useEffect, useState } from 'react'
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    Container,
    Form,
    InputGroup,
    Modal,
    Row,
    Table,
} from 'react-bootstrap'
import './style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { Formik } from 'formik';
import Write from 'asset/SvgComponent/Write'
import Delete from 'asset/SvgComponent/Delete'
import EditIcon from 'asset/SvgComponent/EditIcon'
import Pagination from 'components/Pagination'
import Loader from 'components/Loader'
import Alert from 'components/Alert'
import Dialog from 'components/Dialog'
import axios from 'api/index'
import { IAPI_Response } from 'api/types'
import {
    API_ENDPOINT,
    SUCCESS_MESSAGE,
    ERROR_MESSAGE,
    TEXT
} from 'utils/globalConstant'
import {IList, IMachineList} from "./types";
import moment from "moment/moment";
import Select from "components/ReactSelect";
import {IEmployee} from "../../../Attendance/AttendanceReport/Retail/types";

export default function Index() {
    const [searched, setSearched] = React.useState("")
    const [entries, setEntries] = React.useState(10)

    const [currentPage, setCurrentPage] = React.useState(0)
    const [lastPage, setLastPage] = React.useState(0)
    const [itemsPerPage, setPerPage] = React.useState(10)
    const [itemsCount, setItemCount] = React.useState(0)
    const [from, setFrom] = React.useState(0)

    const [error, setError] = React.useState('')
    const [success, setSuccess] = React.useState('')
    const [showError, setShowError] = React.useState(false)
    const [showSuccess, setShowSuccess] = React.useState(false)
    const [showLoading, setShowLoading] = React.useState(false)

    const [showEdit, setShowEdit] = React.useState(false)
    const handleCloseEdit = () => {
        setShowEdit(false)
        setSelectedEmployeeOption(
            {value: 0, label: "All Employees"}
        )
    }
    const handleShowEdit = () => setShowEdit(true)

    const [data, setData] = React.useState<IList[]>([])
    const [employeeOptions, setEmployeeOptions] = useState<{value: number, label: string}[]>([]);
    const [selectedEmployeeOption, setSelectedEmployeeOption] = useState<{value: number, label: string}>({value: 0, label: "All Employees"})
    const [machine, setMachine] = useState({
        id: 0,
        pc_name: "",
        machine_uiid: ""
    })

    const getMachineList = async (page_number: null | number, searched: string, entries: number) => {
        setShowLoading(true)
        try {
            const response = await axios.get<IAPI_Response<IMachineList>>(API_ENDPOINT.GET_MACHINE_LIST, {
                params: {
                    page: page_number,
                    searched: searched,
                    entries: entries
                },
            })
            const result = await response
            if (result?.data?.results?.data?.length) {
                setData(result?.data?.results?.data)
                setCurrentPage(result?.data?.results?.current_page)
                setLastPage(result?.data?.results?.last_page)
                setPerPage(result?.data?.results?.per_page)
                setItemCount(result?.data?.results?.total)
                setFrom(result?.data?.results?.from)
            }
            setShowLoading(false)
        } catch {
            setShowError(true)
            setError(ERROR_MESSAGE.SYSTEM_ERROR)
        }

        setTimeout(() => {
            setShowError(false)
        }, 3000);
    }

    const showMachine = async (id: number) => {
        console.log("id ", id)
        handleShowEdit()
    }

    const getAllEmployee = async () => {
        try {
            const res = await axios.get<IAPI_Response<IEmployee[]>>(API_ENDPOINT.ALL_EMPLOYEE)
            const result = await res
            if (result?.data?.results?.length) {
                const employees = result?.data?.results;
                setEmployeeOptions([])
                setEmployeeOptions(current => [...current, {value: 0, label: "All Employees"}]);
                employees.map(employee => {
                    setEmployeeOptions(current => [...current, {value: employee.employee_id, label: employee.first_name + " " + employee.last_name}]);
                })

            }
        } catch {
            console.log('There is something wrong')
        }
    }

    const assignMachine = async () => {

        await axios.put(API_ENDPOINT.ASSIGN_MACHINE, {
            'mac_adress_id' : machine.id,
            'employee_id' : selectedEmployeeOption.value
        }).then(response => {
            if (response?.data?.status * 1 === 1) {
                setShowSuccess(true)
                setSuccess(SUCCESS_MESSAGE.ALLOWANCE.UPDATED)
                getMachineList(null, searched, entries);
            }

            handleCloseEdit();
        })

        setTimeout(() => {
            setShowSuccess(false)
            setShowError(false)
        }, 3000);
    }


    useEffect(() => {
        ;(async () => {
            getMachineList(null, searched, entries)
            getAllEmployee()
        })()
    }, [])

    return (
        <>
            <Container fluid>
                <h5 className='fw-bold'>Top Applications</h5>
                <Breadcrumb className='breadcrumbs'>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Monitoring
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Reports
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Top Applications</Breadcrumb.Item>
                </Breadcrumb>

                <Alert
                    type="success"
                    show={showSuccess}
                    message={success}
                    setShow={() => {
                        setShowSuccess(false);
                    }
                    }
                />

                <Alert
                    type="error"
                    show={showError}
                    message={error}
                    setShow={() => {
                        setShowError(false);
                    }
                    }
                />
                <Card className='border-0  p-0 bordered-card'>
                    <Card.Body>
                        <Row>
                            <Col sm={6}>
                                <span className='fw-bold'>&nbsp;</span>
                            </Col>
                            <Col sm={6} className='d-flex justify-content-end hidden'>
                                <InputGroup size='sm' className={'w-25'}>
                                    <Form.Control
                                        aria-label='search'
                                        aria-describedby='inputGroup-sizing-sm'
                                        placeholder='Search...'
                                    />
                                    <InputGroup.Text className='bg-transparent search-input '>
                                        <FontAwesomeIcon icon={faSearch} />
                                    </InputGroup.Text>
                                </InputGroup>
                            </Col>
                        </Row>

                        <Table responsive className='bordered-tabs-top mt-3'>
                            <thead>
                            <tr>
                                <th style={{ width: '10%' }} className='text-center'>
                                    No.
                                </th>
                                <th style={{ width: '50%' }} className='text-center'>
                                    PC Name
                                </th>
                                <th className='text-center'>
                                    Date Created
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {/*<>*/}
                            {/*    {data.length > 0 ? (*/}
                            {/*        data.map((item, index) =>*/}
                            {/*            <tr className='mb-2' key={index}>*/}
                            {/*                <td className={'text-center'}>{from + index}</td>*/}
                            {/*                <td className={'text-center'}>{item.pc_name}</td>*/}
                            {/*                <td>{moment(item.created_at).format("YYYY-MM-DD hh:mm A")}</td>*/}
                            {/*            </tr>*/}
                            {/*        )*/}
                            {/*    ) : (*/}
                            {/*        <tr className='no-item'>*/}
                            {/*            <td colSpan={3}>{TEXT.NOT_FOUND}</td>*/}
                            {/*        </tr>*/}
                            {/*    )}*/}
                            {/*</>*/}
                            </tbody>
                        </Table>

                        <Pagination
                            itemsCount={itemsCount}
                            itemsPerPage={itemsPerPage}
                            currentPage={currentPage}
                            lastPage={lastPage}
                            setCurrentPage={setCurrentPage}
                            alwaysShown={false}
                            pageClicked={(page: number) => {
                                getMachineList(page, searched, entries);
                            }
                            }
                        />
                    </Card.Body>
                </Card>
                {/*<Dialog*/}
                {/*    show={showConfirm}*/}
                {/*    setShow={handleCloseConfirm}*/}
                {/*    setEvent={() => {*/}
                {/*        deleteAllowance(item.allowance_id)*/}
                {/*    }*/}
                {/*    }*/}
                {/*/>*/}

                <Loader show={showLoading}/>

                {/* EDIT MODAL*/}

                <Modal className='modal' centered show={showEdit} onHide={handleCloseEdit}>
                    <Modal.Header closeButton>
                        <Modal.Title className='fw-bold'>Recognize Machine</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={5}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label className='fw-bold'>PC Name: </Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col sm={7}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label >{machine.pc_name}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={5}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label className='fw-bold'>Machine UUID: </Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col sm={7}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label>{machine.machine_uiid}</Form.Label>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={5}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Form.Label className='fw-bold'>Owned By: </Form.Label>
                                    </Form.Group>
                                </Col>
                                <Col sm={7}>
                                    <Form.Group className='mb-1' controlId='exampleForm.ControlInput1'>
                                        <Select
                                            name="employee_id"
                                            value={selectedEmployeeOption}
                                            options={employeeOptions}
                                            onChange={(e: any) => {
                                                setSelectedEmployeeOption(e)
                                                // handleSubmit();
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='outline-primary' size={'sm'} onClick={handleCloseEdit}>
                            Cancel
                        </Button>
                        <Button
                            onClick={assignMachine}
                            type="submit"
                            disabled={selectedEmployeeOption.value == 0 ? true: false}
                            form="allowanceEdit"
                            variant='primary text-white'
                            size={'sm'}
                            className='mx-2'
                        >
                            Assign
                        </Button>
                    </Modal.Footer>
                </Modal>
                <br />
            </Container>
        </>
    )
}
